module.exports = __webpack_public_path__ + "img/page1-3.72c3eed3.png";